import { render } from "./DashboardAuctions.vue?vue&type=template&id=1df0d24c&scoped=true&ts=true"
import script from "./DashboardAuctions.vue?vue&type=script&lang=ts"
export * from "./DashboardAuctions.vue?vue&type=script&lang=ts"

import "./DashboardAuctions.vue?vue&type=style&index=0&id=1df0d24c&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df0d24c"]])

export default __exports__